type FetchOptions = {
  timeout?: number;
} & RequestInit;

/**
 * Fetches data with a timeout.
 * @param resource - The resource URL.
 * @param options - The fetch options, including timeout.
 * @returns The fetch response.
 */
export async function fetchWithTimeout(
  resource: string,
  options: FetchOptions = {},
) {
  const { timeout = 1000 } = options;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
  });
  clearTimeout(id);
  return response;
}
